const eventDelegationDirective = {
  bind(el, binding) {
    const { value } = binding

    el._eventHandlers = el._eventHandlers || {}

    // 为每种事件类型绑定一个处理器
    Object.keys(value).forEach(eventType => {
      const handler = function(event) {
        let currentElement = event.target
        while (currentElement && currentElement !== el) {
          let needBreak = false
          if (hasDataDelegateAttr(currentElement)) {
            // 检查所有可能的委托选择器
            const entries = Object.entries(value[eventType])
            for (let i = 0; i < entries.length; i++) {
              const [selector, handlerObj] = entries[i]
              const attribute = `data-delegate-${selector}`
              if (currentElement.hasAttribute(attribute)) {
                const dataValue = currentElement.getAttribute(attribute)
                handlerObj.handler.call(this, event, currentElement, dataValue)
                event.stopImmediatePropagation()
                needBreak = true
                break // 执行后退出当前事件
              }
            }
          }
          if (needBreak) {
            break
          }
          currentElement = currentElement.parentNode // 向上移动到父节点
        }
      }

      if (!el._eventHandlers[eventType]) {
        el._eventHandlers[eventType] = handler
        el.addEventListener(eventType, handler)
      }
    })
  },

  unbind(el, binding) {
    const { value } = binding

    if (el._eventHandlers) {
      Object.keys(value).forEach(eventType => {
        const handler = el._eventHandlers[eventType]
        if (handler) {
          el.removeEventListener(eventType, handler)
        }
      })
      el._eventHandlers = null
    }
  }
}

// 检查是否有 data-delegate-* 属性
function hasDataDelegateAttr (target) {
  return Object.values(target.attributes).some(attr => attr.name.startsWith('data-delegate-'))
}

export { eventDelegationDirective }
